import React from 'react'
import PropTypes from 'prop-types'
import style from './style'

const H2 = ({ value }) => (
  <div style={style.h2}>
    {value}
  </div>
)

H2.propTypes = {
  value: PropTypes.string
}

export default H2


// WEBPACK FOOTER //
// ./src/components/H2/H2.js